import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import isEmpty from "lodash/isEmpty";
import Select from "react-select";

// Components
import Loader from "../../utils/Loader";
import PermalinkField from "../../utils/PermalinkField";
import DeleteConfirmationDialog from "../../utils/DeleteConfirmationDialog";

// CSS
import "../../../css/react-select.css";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

class AdminCategoriesForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: {
				id: !!props.match.params.id ? props.match.params.id : ""
			},
			categories: [],
			isLoading: !!props.match.params.permalink ? true : false,
			addSucccess: !!props.location.state ? props.location.state.successMessage : "",
			updateLoading: false,
			updateErrors: {},
			updateSuccess: "",
			showDeleteConfirmationDialog: false,
			deletionInProgress: false,
			deleteErrors: "",
			deleteSuccess: ""
		};

		// Remove state from history object (success messages, etc)
		if (!!props.location.state) {
			props.history.replace({
				pathname: props.history.location.pathname
			});
		}
	}

	componentDidMount() {
		if (this.state.data.id) {
			this.loadData();
		} else {
			this.loadCategories();
		}
	}

	loadData() {
		this.setState(
			{
				isLoading: true
			},
			() => {
				const { id } = this.state.data;

				const apiEndpoint = "categories/" + id;

				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token
				};
				return axios
					.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
					.then(response => {
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({ isLoading: false, error: response.data.message });
						} else {
							this.setState({
								isLoading: false,
								data: { ...response.data },
								categories: response.data.categories
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								isLoading: false,
								error: err.response.data.errors
									? err.response.data.errors
									: err.response.data.message
							});
						} else {
							this.setState({ isLoading: false, error: err.message });
						}
					});
			}
		);
	}

	loadCategories() {
		this.setState(
			{
				isLoading: true
			},
			() => {
				const apiEndpoint = "categories";

				const AUTH_HEADER = {
					Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token
				};
				return axios
					.get(REACT_APP_API_URL + apiEndpoint, { headers: AUTH_HEADER })
					.then(response => {
						if (
							response.status !== 200 ||
							(response.data.status && response.data.status !== 200)
						) {
							this.setState({ isLoading: false, error: response.data.message });
						} else {
							this.setState({
								isLoading: false,
								categories: [
									{ value: "", title: "Top" },
									...response.data.categories
								]
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								isLoading: false,
								error: err.response.data.errors
									? err.response.data.errors
									: err.response.data.message
							});
						} else {
							this.setState({ isLoading: false, error: err.message });
						}
					});
			}
		);
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSubmit();
		}
	}

	handleInputChange(event) {
		const { id, value } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[id]: value
			}
		});
	}

	handleCheckboxClick(event) {
		const { id } = event.target;
		this.setState({
			data: {
				...this.state.data,
				[id]: !this.state.data[id]
			}
		});
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	handleSubmit() {
		const { user } = this.props;
		const data = {
			...this.state.data,
			parent: this.state.data.parent_id
		};

		this.setState({
			updateErrors: {},
			updateLoading: true
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.post(REACT_APP_API_URL + "categories", data, { headers: AUTH_HEADER })
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						updateLoading: false,
						updateErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: { general: response.data.message }
					});
				} else {
					// Redirect to store edit route
					if (!data.id) {
						this.props.history.push({
							pathname: "/admin/categories/edit/" + response.data.id,
							state: {
								successMessage: response.data.message
							}
						});
					}

					this.setState({
						updateLoading: false,
						updateSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						updateLoading: false,
						updateErrors: {
							general: err.response.data.error
								? err.response.data.error
								: err.response.data.message
						}
					});
				} else {
					this.setState({
						updateLoading: false,
						updateErrors: { general: err.message }
					});
				}
			});
	}

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete(permalink) {
		const { user } = this.props;

		this.setState({
			deletionInProgress: true,
			deleteErrors: {},
			deleteSuccess: ""
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.delete(REACT_APP_API_URL + "categories/" + this.state.data.id, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: !isEmpty(response.data.errors)
							? response.data.errors
							: response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.response.data.error
							? err.response.data.error
							: err.response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.message
					});
				}
			});
	}

	handleDeleteRedirect() {
		this.props.history.push("/admin/categories/edit/");
	}

	render() {
		const {
			data,
			categories,
			addSucccess,
			updateErrors,
			updateSuccess,
			updateLoading
		} = this.state;
		const { id, title, permalink, parent_id, hidden } = data;

		return (
			<div>
				{!this.props.match.params.id && <h1>Add Category</h1>}

				{/* Loading */}
				{this.state.isLoading ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					// Show the form
					<div>
						{!!addSucccess && <div className="success msg_animate">{addSucccess}</div>}

						{!this.props.match.params.permalink || id ? (
							<div>
								{!!id && <input type="hidden" id="id" value={id} />}

								<div className="fieldset">
									<div className="form-field">
										<label>Title:</label>

										{!!updateErrors.title && (
											<div className="error msg_animate">
												{updateErrors.title}
											</div>
										)}
										<input
											type="text"
											id="title"
											value={title}
											maxLength="255"
											onKeyPress={e => this.handleKeyPress(e)}
											onChange={e => this.handleInputChange(e)}
										/>
									</div>

									<div className="form-field">
										<label>Permalink:</label>

										{!!updateErrors.permalink && (
											<div className="error msg_animate">
												{updateErrors.permalink}
											</div>
										)}
										<PermalinkField
											tableName={"categories"}
											id={id}
											value={permalink}
											controlFieldValue={title}
											fieldError={updateErrors.permalink}
											handleSubmit={this.handleSubmit.bind(this)}
											handleChange={res =>
												this.setState({
													data: { ...this.state.data, permalink: res }
												})
											}
										/>
									</div>

									<div className="floated-field-container">
										<div className="form-field half-field">
											<label>Parent:</label>

											{!!updateErrors.parent && (
												<div className="error msg_animate">
													{updateErrors.parent}
												</div>
											)}
											{console.log(categories)}
											<Select
												classNamePrefix="react-select"
												name={`parent_id`}
												placeholder="Choose parent category"
												value={categories.filter(
													({ id }) => id === parent_id
												)}
												onChange={selection =>
													this.setState({
														data: {
															...this.state.data,
															parent_id: selection.id
														}
													})
												}
												isClearable={false}
												getOptionLabel={({ title }) => title}
												getOptionValue={({ id }) => id}
												options={categories}
											/>
										</div>
									</div>

									<div className="form-field">
										{!!updateErrors.hidden && (
											<div className="error msg_animate">
												{updateErrors.hidden}
											</div>
										)}
										<div className="custom-label checkbox-label no-bottom-margin">
											<input
												type="checkbox"
												id="hidden"
												value="1"
												checked={hidden}
												onChange={e => this.handleCheckboxClick(e)}
											/>
											<label htmlFor="hidden">Hidden</label>
										</div>
									</div>
								</div>

								<div className="btn_container">
									{!!updateErrors.general && (
										<div className="error msg_animate">
											{updateErrors.general}
										</div>
									)}

									{updateSuccess && (
										<div className="success msg_animate">{updateSuccess}</div>
									)}

									<button
										className={
											"btn submit-btn" + (updateLoading ? " loading" : "")
										}
										onClick={() => this.handleSubmit()}
										disabled={updateLoading}
									>
										<span>{!!id ? "Update" : "Create"}</span>
									</button>
									{!!data.id && (
										<button
											className={
												"btn delete-btn" + (updateLoading ? " loading" : "")
											}
											onClick={() =>
												this.setState({
													showDeleteConfirmationDialog: true
												})
											}
											disabled={updateLoading}
										>
											Delete
										</button>
									)}
								</div>

								<DeleteConfirmationDialog
									show={this.state.showDeleteConfirmationDialog}
									deletionInProgress={this.state.deletionInProgress}
									id={id}
									itemTitle={title}
									handleDelete={this.handleDelete.bind(this)}
									handleDeleteRedirect={this.handleDeleteRedirect.bind(this)}
									handleClose={() =>
										this.setState({ showDeleteConfirmationDialog: false })
									}
									deleteErrors={this.state.deleteErrors}
									deleteSuccess={this.state.deleteSuccess}
								/>
							</div>
						) : (
							<div>Location not found</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(
	mapStateToProps,
	{ userTokenUpdate, userLogout }
)(AdminCategoriesForm);



// WEBPACK FOOTER //
// ./src/components/admin/categories/AdminCategoriesForm.js